import styled, { keyframes } from 'styled-components';

const FullPageLoader = ({ text = 'Loading', logo = null }) => {
  return (
    <LoadingOverlay data-testid='loading-overlay'>
      <LoadingContainer>
        {logo && <Logo src={logo} alt='Logo' />}
        <LoadingText>{text}</LoadingText>
      </LoadingContainer>
    </LoadingOverlay>
  );
};

const LoadingOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 10px;
`;

const ellipsisAnimation = keyframes`
  0% { content: ''; }
  25% { content: '.'; }
  50% { content: '..'; }
  75% { content: '...'; }
  100% { content: ''; }
`;

const LoadingText = styled.div`
  color: white;
  font-size: 30px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    animation: ${ellipsisAnimation} 2s linear infinite;
  }
`;

export default FullPageLoader;
